// @/composables/useConfirm.js
import { reactive } from 'vue'

export const confirmState = reactive({
  open: false,
  title: '',
  message: '',
  confirmText: 'Aceptar',
  cancelText: 'Cancelar',
  confirmClass: 'btn-primary', // o 'btn-danger' según la acción
  panelClass: '',
  closable: true,
  placement: 'center',
})

let _resolver = null

export function confirm(options = {}) {
  Object.assign(confirmState, {
    title: '',
    message: '',
    confirmText: 'Aceptar',
    cancelText: 'Cancelar',
    confirmClass: 'btn-primary',
    panelClass: '',
    closable: true,
    placement: 'center',
    ...options,
    open: true,
  })
  return new Promise((resolve) => { _resolver = resolve })
}

export function resolveConfirm(value) {
  confirmState.open = false
  if (_resolver) {
    _resolver(!!value)
    _resolver = null
  }
}
